module.exports = "https://static.cdns.space/qurangrowth-temp/img/p3.f973fe8c.webp";